import { ChangeDetectorRef, Injectable } from '@angular/core';
import { act, Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, tap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as fromScheduleActions from '../actions/schedule.action';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { NavigationExtras, Router } from '@angular/router';
import { setLoadingSpinner } from '../actions/shared.action';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { getUserProfile } from '../actions/account.action';
import { ScheduleService } from 'src/app/services/schedule.service';
import { getGeneratedSchedules } from '../actions/schedule.action';

@Injectable()
export class ScheduleEffects {

  getGeneratedSchedules$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromScheduleActions.getGeneratedSchedules),
      exhaustMap((action) => 
        this.scheduleService.getGeneratedSchedules(action?.data).pipe(
          map((response)=>{
            this.store.dispatch(setLoadingSpinner({status: false}))
            return fromScheduleActions.getGeneratedSchedulesSuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromScheduleActions.getGeneratedSchedulesFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getGeneratedSchedulesSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.getGeneratedSchedulesSuccess),
        tap(async (action) =>{
          console.log("getGeneratedSchedulesSuccess$",action.data);
        })
      ),
    { dispatch: false }
  );

  getGeneratedSchedulesFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.getGeneratedSchedulesFailed),
        tap(async (action) =>{
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  generateSchedule$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromScheduleActions.generateSchedule),
      exhaustMap((action) => 
        this.scheduleService.generateSchedule(action?.data, action?.data?.school_year_term).pipe(
          map((response)=>{
            return fromScheduleActions.generateScheduleSuccess({data: response?.details?.process_id})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromScheduleActions.generateScheduleFailed({data : response?.error?.message}))
          })
        )
      )
    )
  )

  generateScheduleSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.generateScheduleSuccess),
        tap(async (action) =>{
          this.store.dispatch(fromScheduleActions.getGeneratedScheduleProgress({data: action?.data}))
        })
      ),
    { dispatch: false }
  )

  generateScheduleFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.generateScheduleFailed),
        tap(async (action) =>{
          if(action.data){
            this.modalService.errorModal(action?.data)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  )

  getGeneratedScheduleProgress$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromScheduleActions.getGeneratedScheduleProgress),
      exhaustMap((action) => 
        this.scheduleService.getGeneratedScheduleProgress(action?.data).pipe(
          map((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return fromScheduleActions.getGeneratedScheduleProgressSuccess({data: response?.details?.message})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromScheduleActions.getGeneratedScheduleProgressFailed({data : response?.error?.message}))
          })
        )
      )
    )
  )

  getGeneratedScheduleProgressSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.getGeneratedScheduleProgressSuccess),
        tap(async (action) =>{
          const message = {
            message: action?.data
          }
          this.modalService.successModal(message);
        })
      ),
    { dispatch: false }
  )

  getGeneratedScheduleProgressFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.getGeneratedScheduleProgressFailed),
        tap(async (action) =>{
          if(action.data){
            this.modalService.errorModal(action?.data)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  )

  getGeneratedScheduleDetails$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromScheduleActions.getGeneratedScheduleDetails),
      exhaustMap((action) => 
        this.scheduleService.getScheduleAvailable(action?.data, action?.student?.id).pipe(
          map((response)=>{
            this.store.dispatch(setLoadingSpinner({status: false}))
            return fromScheduleActions.getGeneratedScheduleDetailsSuccess({data: response?.details, student: action?.student})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromScheduleActions.getGeneratedScheduleDetailsFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getGeneratedScheduleDetailsSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.getGeneratedScheduleDetailsSuccess),
        tap(async (action) =>{
          console.log("getGeneratedScheduleDetailsSuccess$",action.data);
        })
      ),
    { dispatch: false }
  );

  getGeneratedScheduleDetailsFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.getGeneratedScheduleDetailsFailed),
        tap(async (action) =>{
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  confirmSchedule$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.confirmSchedule),
        tap(async (action) =>{
          this.router.navigate(['/home/registrar/assign-schedule/view-schedule-confirm'])
        })
      ),
    { dispatch: false }
  );

  generateStudentSchedule$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromScheduleActions.generateStudentSchedule),
      exhaustMap((action) => 
        this.scheduleService.generateStudentSchedules(action?.student?.id, action?.data).pipe(
          map((response)=>{
            this.store.dispatch(setLoadingSpinner({status: false}))
            this.modalService.hideAssignStudentScheduleConfirm();
            return fromScheduleActions.generateStudentScheduleSuccess({data: response?.details?.result, student: action?.student, schedule: action?.schedule, preview: action?.data?.preview})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromScheduleActions.generateStudentScheduleFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  generateStudentScheduleSuccess$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromScheduleActions.generateStudentScheduleSuccess),
        tap(async (action) =>{
          if(action?.preview){
            this.router.navigateByUrl('/home/registrar/assign-schedule/schedule-preview');
            if(action?.data?.conflict?.length > 0 || action?.data?.exists?.length > 0 || action?.data?.full?.length > 0){
              const message = {
                title: 'Something went wrong.',
                message: 'Some of the subjects are not added to the student`s schedule. Please check the table below.'
              }
              this.modalService.errorModal(message)
            } else{
              const message = {
                message: 'Student schedule successfully generated. Kindly review the details.'
              }
              this.modalService.successModal(message)
            }
          } else {
            this.router.navigateByUrl('/home/registrar/assign-schedule/student-list');
            const message = {
              message: 'Student schedule successfully generated. Kindly review the details.'
            }
            this.modalService.successModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  generateStudentScheduleFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.generateStudentScheduleFailed),
        tap(async (action) =>{
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  finalizeSchedule$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromScheduleActions.finalizeSchedule),
      exhaustMap((action) => 
        this.scheduleService.finalizeSchedule(action?.data).pipe(
          map((response)=>{
            return fromScheduleActions.finalizeScheduleSuccess({data: response?.message, term_id: action?.term_id})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromScheduleActions.finalizeScheduleFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  finalizeScheduleSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.finalizeScheduleSuccess),
        tap(async (action) =>{
          this.store.dispatch(getGeneratedSchedules({data: action?.term_id}));
        })
      ),
    { dispatch: false }
  );

  finalizeScheduleFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.finalizeScheduleFailed),
        tap(async (action) =>{
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  getScheduleDetailsOptions$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromScheduleActions.getScheduleDetailsOptions),
      exhaustMap((action) => 
        this.scheduleService.getGeneratedScheduleDetails(action?.data).pipe(
          map((response)=>{
            return fromScheduleActions.getScheduleDetailsOptionsSuccess({data: response?.details, schedule_id: action?.data})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromScheduleActions.getScheduleDetailsOptionsFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getScheduleDetailsOptionsSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.getScheduleDetailsOptionsSuccess),
        tap(async (action) =>{
          this.modalService.hideCreateScheduleDetailsConfirm();
          this.store.dispatch(fromScheduleActions.getSchedulesUnmatched({data: action?.schedule_id}))
        })
      ),
    { dispatch: false }
  );

  getScheduleDetailsOptionsFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.getScheduleDetailsOptionsFailed),
        tap(async (action) =>{
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  getSchedulesUnmatched$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromScheduleActions.getSchedulesUnmatched),
      exhaustMap((action) => 
        this.scheduleService.getSchedulesUnmatched(action?.data).pipe(
          map((response)=>{
            return fromScheduleActions.getSchedulesUnmatchedSuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromScheduleActions.getSchedulesUnmatchedFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getSchedulesUnmatchedSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.getSchedulesUnmatchedSuccess),
        tap(async (action) =>{
          this.store.dispatch(setLoadingSpinner({status: false}));
          this.router.navigateByUrl('/home/administration/setup/schedule-details')
        })
      ),
    { dispatch: false }
  );

  getSchedulesUnmatchedFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.getSchedulesUnmatchedFailed),
        tap(async (action) =>{
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  createScheduleDetails$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromScheduleActions.createScheduleDetails),
      exhaustMap((action) => 
        this.scheduleService.createScheduleDetails(action?.data).pipe(
          map((response)=>{
            return fromScheduleActions.createScheduleDetailsSuccess({data: response?.message, schedule_id: action?.data?.schedule_id})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromScheduleActions.createScheduleDetailsFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  createScheduleDetailsSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.createScheduleDetailsSuccess),
        tap(async (action) =>{
          this.store.dispatch(fromScheduleActions.getScheduleDetailsOptions({data: action?.schedule_id}));
        })
      ),
    { dispatch: false }
  );

  createScheduleDetailsFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.createScheduleDetailsFailed),
        tap(async (action) =>{
          this.modalService.hideCreateScheduleDetailsConfirm();
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  updateScheduleDetails$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromScheduleActions.updateScheduleDetails),
      exhaustMap((action) => 
        this.scheduleService.updateScheduleDetails(action?.data).pipe(
          map((response)=>{
            return fromScheduleActions.updateScheduleDetailsSuccess({data: response?.message, schedule_id: action?.data?.schedule_id})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromScheduleActions.updateScheduleDetailsFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  updateScheduleDetailsSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.updateScheduleDetailsSuccess),
        tap(async (action) =>{
          this.store.dispatch(fromScheduleActions.getScheduleDetailsOptions({data: action?.schedule_id}));
        })
      ),
    { dispatch: false }
  );

  updateScheduleDetailsFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromScheduleActions.updateScheduleDetailsFailed),
        tap(async (action) =>{
          this.modalService.hideCreateScheduleDetailsConfirm();
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private scheduleService: ScheduleService,
    private router: Router,
    private modalService: ModalService
  ) {}
}
